import styled from 'styled-components';

import { Button } from 'app/theme/Button';
import { common } from 'app/translations/dictionary';

interface FileUploaderSubmitButtonProps {
  isLoading: boolean;
}

const PaddedButton = styled(Button)<{ $isLoading: boolean }>`
  &&& {
    flex-grow: 1;
    max-height: 6rem;
    font-size: 2rem;
    display: flex;
    align-items: center;

    justify-content: center;
    box-shadow: ${({ $isLoading }) => ($isLoading ? 'none' : '0.3rem 0.3rem 0.7rem rgba(186, 47, 68, 0.4)')};
    ${({ theme, $isLoading }) => $isLoading && `background-color: ${theme.palette.gray.silverChalice}`};

    &:hover,
    &:focus {
      ${({ theme, $isLoading }) => $isLoading && `background-color: ${theme.palette.gray.silverChalice}`};
    }
  }
`;

export const FileUploaderSubmitButton = ({ isLoading }: FileUploaderSubmitButtonProps): JSX.Element => (
  <PaddedButton data-testid="submit-files" type="submit" $isLoading={isLoading} fluid primary>
    {common.submit}
  </PaddedButton>
);
